import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv1 = () => {
  return <header className="bg-white" data-id="element-17005">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17006"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17007">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17008">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17009">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17010">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-17011">
          <div className="text-xs text-gray-400 font-sans" data-id="element-17012">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17013">
          <div className="text-left" data-id="element-17014">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17015">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17016">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17017">
        <div className="max-w-4xl mx-auto" data-id="element-17018">
          <div className="flex items-center text-xs text-gray-500 mb-4 border-b border-gray-200 pb-2" data-id="element-17019">
            <div className="flex items-center mr-4" data-id="element-17020">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-17021" />
              <span data-id="element-17022">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-17023">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-17024" />
              <span data-id="element-17025">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17026">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17027">
            73-Year-Old Corning Engineer Exposes Why All Grounding Sheets Fail —
            Then Builds Ones That Don't
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17028">
            How submarine cable technology and $388,716 in retirement savings
            led to the only grounding sheets that still work after 1,000 washes
          </p>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17029">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17030">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-17031" />
            </div>
            <div className="flex-1" data-id="element-17032">
              <div className="flex items-center" data-id="element-17033">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17034">
                  By Tom Davidson
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17035">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17036" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17037">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17038">
                Retired Electrical Engineer, Corning Inc. | As told to
                Traditional Medicine Publications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17039">
                <div className="flex items-center mr-4" data-id="element-17040">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17041" />
                  <span data-id="element-17042">9 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17043">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17044" />
                  <span data-id="element-17045">18,342 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5" data-id="element-17046">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/232sjW71qLLR3zci5F48Jb/1_Tom_Davidson.png" alt="Tom Davidson working at his desk with engineering equipment" className="w-full rounded-lg shadow-md" data-id="element-17047" />
          </div>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17048">
            <div className="mb-1 flex items-center" data-id="element-17049">
              <span className="font-medium mr-2" data-id="element-17050">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17051">
              <span className="font-medium mr-2" data-id="element-17052">Published:</span>
              November 2025
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv1;